export const convertMinuteToHoursHandler = (time: number) => {
  const dec = time / 60;

  return dec.toFixed(2);
};